import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as LinkedIn } from '../../../assets/img/linked-in-black.svg';
import { ReactComponent as Twitter } from '../../../assets/img/twitter-black.svg';
import GlobalStyle from "../../../GlobalStyle";
import { Button, message } from "antd";
import { submitPreferencesI2c } from '../action';
import { useHistory } from "react-router-dom";
import { removeGillRoyIcon } from 'utils';

const UnSubSorryPage = (props: any) => {
  const logo = 'https://www.i2cinc.com/pardot-landing-pages/images/i2c_logo.svg';
  const sorryLogo = 'https://www.i2cinc.com/pardot-landing-pages/images/sorry-img.svg'
  const current_year = new Date().getFullYear();
  const history = useHistory();
  const [buttonDisable, setButtonDisable] = useState(false);

  const onHandleClick = () => {
    let unsubid = props.match.params.unsubid;
    setButtonDisable(true);
    submitPreferencesI2c({
      unsub_uuid: unsubid,
      unsub_flag: '0'
    }).then((res) => {
      if (res) {
        setTimeout(() => setButtonDisable(false), 1000);
        // console.log('response: ', res);
        if (res.data['status'] === 'True') {
          message.success(res.data['msg'], 5);
          let resub_url = '/unsub/i2c/' + unsubid;
          history.push(resub_url);
        }
        else {
          message.error(res.data['msg'], 5)
          setTimeout(() => setButtonDisable(false), 3000);
        }
      } else {
        // console.log("couldn't fetch response ofr unsub");
      }
    })
      .catch((err) => {
        message.error('Something went wrong', 5);
        setTimeout(() => setButtonDisable(false), 3000);
      });
  }

  useEffect(() => {
    removeGillRoyIcon();
  }, [])


  return (
    <Wrapper>
      <GlobalStyle />
      <div className='inner-content'>
        <a href='https://www.i2cinc.com/' target='_blank' title='i2c Inc.'>
          <img
            className='img-fluid'
            src={logo}
            alt='12c-logo'
          />
        </a>
        <div className='unsubscribe-box'>
          <img src={sorryLogo} alt="" />
          <h6 className='box-heading'>We're sorry to see you go!</h6>
          <p className='box-text text-center'>You initially subscribed to our emails or newsletters because you wanted to receive great information about i2c, and we enjoyed providing you with these valuable insights and trending data.</p>
          <p className='box-text text-center'>Please feel free to reach back out to us if you're interested in rejoining i2c's communications.</p>
          <Button
            className='box-button'
            type='primary'
            size='large'
            disabled={buttonDisable}
            onClick={onHandleClick}
          >
            Resubscribe
          </Button>
        </div>
      </div>
      <div className='footer-div'>
        <div className='logo-div'>
          <a href='https://www.i2cinc.com/' target='_blank' title='i2c Inc.'>
            <img
              className='img-logo-i2c'
              src={logo}
              alt='12c-logo'
            />
          </a>
          <div className='follow-div'>
            <span className='follow-text'>Follow us:</span>
            <div className='icons-div'>
              <a href='https://www.linkedin.com/company/242586/' target='_blank' title='Follow us on LinkedIn' rel='noreferrer'>
                <LinkedIn />
              </a>
              <a href='https://twitter.com/i2cinc' target='_blank' title='Follow us on Twitter' rel='noreferrer'>
                <Twitter />
              </a>
            </div>
          </div>
        </div>
        <div className='policy-rights-div'>
          <div className='d-flex footer-actions'>
            <a href='https://www.i2cinc.com/privacy-policy/' target='_blank'>
              <span className='policy-text'>Privacy Policy</span>
            </a>
            <a href='https://www.i2cinc.com/contact-us/' target='_blank'>
              <span className='policy-text mb-c'>Contact Us</span>
            </a>
          </div>
          <span className='policy-text-rights bold'>i2c Inc. © {current_year} All Rights Reserved.</span>
        </div>
      </div>
    </Wrapper >
  );
};

export default UnSubSorryPage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 30px 60px;
  background-color: #fff;
  min-height: 100vh;
  height: auto;
  justify-content: space-between;
  @media all and (max-width: 550px) { 
    height: auto;
    padding: 30px 10px;
  }
  .footer-actions {
    @media all and (max-width: 450px) {
      a span {
        margin-left: 0px !important;
        margin: 4px 0px;
        display: inline-block;
      }
    }
    a {
      &:nth-child(1) {
        span {
          margin-right: 50px;
        }
      }
    }
  }
  .inner-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-fluid {
      max-width: 90px;
      height: 90px;
    }
    .unsubscribe-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.102473);
      max-width: 780px;
      padding: 30px 150px;
      border-radius: 12px;
      margin-top: 40px;
      margin-bottom: 50px;
      @media all and (max-width: 992px) {
        max-width: auto;
        padding: 30px;
        margin-bottom: 40px;
      }
      @media all and (max-width: 550px) {
        padding: 50px 10px;
      }
      .box-heading {
        font-family: 'Roboto';
        color: #000;
        font-size: 26px;
        line-height: 30px;
        margin-bottom: 20px;
        margin-top: 20px;
        text-align: center;
        font-weight: 500;
        @media all and (max-width: 992px) {
            font-size: 22px;
            line-height: 30px;
            margin: 0 0 28px;
        }
      }
      .box-text {
        font-family: 'Roboto';
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 24px;
        padding: 0;
        color: #000000;
      }
      .box-button {
        border: 1px solid #EF9829;
        font-family: 'Roboto';
        color: #fff;
        background-color: #EF9829;
        font-size: 16px;
        line-height: 22px;
        cursor: pointer;
        padding: 10px 20px;
        border-radius: 5px;
        margin-bottom: 15px;
        text-transform: uppercase;
        &:hover{
          background-color: white;
          color: #EF9829;
        }
      }
    }
  }
  .footer-div {
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid #DADADA;
    padding: 40px 20px 20px;
    max-width: 1320px;
    position: relative;
    @media all and (max-width: 992px) {
      padding: 40px 0px 20px 0px;
    }
    @media only screen and (min-width: 1025px) and (max-width: 1440px){
      max-width: 1260px;
    }
    @media (max-width: 1440px) {
      max-width: 1210px;
    }
    @media only screen and (max-width: 1280px){
      max-width: 990px;
      padding: 0 20px!important; 
    }
    @media only screen and (max-width: 767px) {
      padding: 0!important;
    }
    @media only screen and (max-width: 580px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .logo-div {
      display: flex;
      align-items: center;
      .img-logo-i2c {
        height: 90px;
        width: 90px;
        @media all and (max-width: 650px) {
          width: 60px;
          height: 60px;
        }
      }
      .follow-div {
        margin-left: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /* height: 100%; */
        @media all and (max-width: 650px) {
          margin-left: 10px;
          margin-top: -3px;
        }
        .follow-text {
          font-family: 'Roboto';
          color: #000;
          font-size: 16px;
          line-height: 18px;
          margin-left: 9px;
          margin-top: 20px;
        }
        .icons-div {
          display: flex;
          align-items: center;
          .img-icons {
            width: 45px;
            height: 45px; 
            &.ml {
              margin-left: 10px;
              width: 25px;
              height: 25px;
            }
          }
        } 
        svg {
          transition: 0.5s ease all;
          &:hover {
            path {
              fill: #EF9829;
            }
          }
        }
      }
    }
    .policy-text-rights {
      margin-top: 15px;
      display: inline-block;
      font-weight: 400;
      color: #000;
      text-align: right;
      width: 100%;
      @media all and (max-width: 580px) {
        text-align: left;
      }
    }
    .policy-rights-div {
      padding-top: 15px;
        .policy-text {
          font-family: 'Roboto';
          font-weight: 300;
          color: #000;
          font-size: 18px;
          &:hover {
            color: #EF9829;
            font-weight: 300;
            transition: .25s;
          }
          &.bold {
            font-size: 14px;
            font-weight: 400;
            margin-left: 10px;
            margin-bottom: 30px;
          }
        }
      }
  }
`;
